<script setup lang="ts">
import { watch } from "vue";
import { useRoute } from "vue-router";
import "@/assets/styles/main.css";

const route = useRoute();
watch(() => route.meta.title, (title) => { document.title = `${title || "Start"} · Freiraum GaLaBau`; }, { immediate: true });
</script>

<template><router-view /></template>
